import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/(unrestricted-width)/news/components/News.tsx");
